import { useCallback, useMemo, useState } from "react";
import Modal from "../../../components/generic/Modal";
import { AddAdvisorModalBody } from "./styles";
import { useDispatch } from "react-redux";
import { saveAdvisors } from "../../../store/branch/thunks";
import UserSelect from "../../../components/shared/UserSelect";

const AddUserModal = (props) => {
  const { handleCancel, users = [], selectedBranch, selectedTenantId } = props;
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const dispatch = useDispatch();

  const availableUsers = useMemo(() => {
    return users?.filter(
      ({ id }) => !selectedBranch?.users.some(({ user_id }) => user_id === id)
    );
  }, [users, selectedBranch]);

  const handleSubmit = useCallback(async () => {
    try {
      setSubmitting(true);

      await dispatch(
        saveAdvisors({
          user_ids: selectedUsers,
          branch_id: selectedBranch?.id,
          tenant_id: selectedTenantId,
        })
      );
      handleCancel();
    } catch (error) {
      console.log("🚀 ~ AddUserModal.jsx:23 ~ AddUserModal ~ error:", error);
    } finally {
      setSubmitting(false);
    }
  }, [selectedUsers, selectedTenantId, selectedUsers]);

  return (
    <Modal
      title={`Add Users to "${selectedBranch?.name}" Branch`}
      onCancel={handleCancel}
      width={480}
      open
      onOk={handleSubmit}
      isProcessing={submitting}
      okButtonProps={{
        loading: submitting,
        disabled: submitting,
      }}
    >
      <AddAdvisorModalBody>
        <UserSelect
          users={availableUsers}
          value={selectedUsers}
          onChange={setSelectedUsers}
          listTitle={"Selected Members"}
        />
      </AddAdvisorModalBody>
    </Modal>
  );
};

export default AddUserModal;
